import React from 'react'

import { Icons } from '../utils/Icons'
import iconWsp from "../assets/img/whatsapp.svg"
import iconMail from "../assets/img/mail.svg"

export const Footer = () => {

  return (
    <div className="footerWrap">
      <div className="mainWidth">
        <p>¿No encuentras lo que buscas o tienes alguna sugerencia?</p>
        <div>
          <a 
            href="mailto: contacto@megago.cl"
            className="borderButtonLink"
          >
            <Icons path={iconMail} />
            contacto@megago.cl
          </a>
        </div>
      </div>
    </div>
  )
}
